"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = require("@0x/assert");
var json_schemas_1 = require("@0x/json-schemas");
exports.assert = __assign({}, assert_1.assert, { isValidBuyQuote: function (variableName, buyQuote) {
        assert_1.assert.isHexString(variableName + ".assetData", buyQuote.assetData);
        assert_1.assert.doesConformToSchema(variableName + ".orders", buyQuote.orders, json_schemas_1.schemas.signedOrdersSchema);
        assert_1.assert.doesConformToSchema(variableName + ".feeOrders", buyQuote.feeOrders, json_schemas_1.schemas.signedOrdersSchema);
        exports.assert.isValidBuyQuoteInfo(variableName + ".bestCaseQuoteInfo", buyQuote.bestCaseQuoteInfo);
        exports.assert.isValidBuyQuoteInfo(variableName + ".worstCaseQuoteInfo", buyQuote.worstCaseQuoteInfo);
        assert_1.assert.isBigNumber(variableName + ".assetBuyAmount", buyQuote.assetBuyAmount);
        if (buyQuote.feePercentage !== undefined) {
            assert_1.assert.isNumber(variableName + ".feePercentage", buyQuote.feePercentage);
        }
    },
    isValidBuyQuoteInfo: function (variableName, buyQuoteInfo) {
        assert_1.assert.isBigNumber(variableName + ".assetEthAmount", buyQuoteInfo.assetEthAmount);
        assert_1.assert.isBigNumber(variableName + ".feeEthAmount", buyQuoteInfo.feeEthAmount);
        assert_1.assert.isBigNumber(variableName + ".totalEthAmount", buyQuoteInfo.totalEthAmount);
    },
    isValidOrderProvider: function (variableName, orderFetcher) {
        assert_1.assert.isFunction(variableName + ".getOrdersAsync", orderFetcher.getOrdersAsync);
    },
    isValidOrderProviderRequest: function (variableName, orderFetcherRequest) {
        assert_1.assert.isHexString(variableName + ".makerAssetData", orderFetcherRequest.makerAssetData);
        assert_1.assert.isHexString(variableName + ".takerAssetData", orderFetcherRequest.takerAssetData);
    },
    isValidPercentage: function (variableName, percentage) {
        exports.assert.isNumber(variableName, percentage);
        exports.assert.assert(percentage >= 0 && percentage <= 1, "Expected " + variableName + " to be between 0 and 1, but is " + percentage);
    } });
//# sourceMappingURL=assert.js.map